import { Injectable } from '@angular/core';
import { url } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class HomePageService {
  web = url.web;
  cloudinary = url.cloudinary;
  year = new Date().getFullYear();
  formUrl = 'https://formsubmit.co/bank3dsales@parkwayprojects.com';
  loading = false;
  loading2 = false;

  submitNewsletterForm() {
    const form = document.querySelector('form').reportValidity();
    console.log(form, this.loading);
    if (form === true) {
      this.loading = true;
    }
  }

  submitContactForm() {
    const form = document.querySelectorAll('form')[1].reportValidity();
    if (form === true) {
      this.loading2  = true;
    }
  }
  shared() {
    const menu = document.getElementById('menu');
    const logo = document.getElementById('logo');
    const toggleMenu = document.querySelectorAll('.toggle-menu');
    const navLinks = document.getElementsByClassName('.toggle-menu a');
    const navContainer = document.getElementById('navContainer');
    const inputRadio = document.querySelectorAll('input[type="radio"]');
    const faqAnswer = document.querySelectorAll('.faq-answer');

    menu.addEventListener('click', () => {
      menu.classList.toggle('opened');
      navContainer.classList.toggle('h-100');
    });

    logo.addEventListener('click', () => {
      openCloseMenu();
    });

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < toggleMenu.length; i++) {
      toggleMenu[i].addEventListener('click', () => {
        openCloseMenu();
      });
    }

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < inputRadio.length; i++) {
      const isChecked = inputRadio[i];
      isChecked.addEventListener('click', () => {
        isChecked.parentNode.children[0].children[1].classList.toggle('rotate');
        if (isChecked) {
          isChecked.nextElementSibling.classList.toggle('mh-100');
        }
      });
    }

    const openCloseMenu = () => {
      menu.classList.remove('opened');
      navContainer.classList.remove('h-100');
    };
  }
}
